import '../../styles/App.css';

const AnimationBox = ({ children, className = '', style = {} }) => {
    return (
        <div className={`animation-box ${className}`} style={style}>
            <div className="animation-box-circle" />
            <div className="animation-box-inner">
                {children}
            </div>
        </div>
    );
};

export default AnimationBox;
